import { useState } from 'react';
import { Card, Combobox, EmptyState } from '../components/atoms';
import { SectionHeader } from '../components/molecules';
import { RuleTargetsTable, RulesTable } from '../components/organisms';
import { PageTemplate } from '../components/templates';
import { useRuleTargets, useRules } from '../lib/api';

const ALL_TARGETS = '';

export function RulesPage() {
  const [targetFilter, setTargetFilter] = useState(ALL_TARGETS);
  const targetsQuery = useRuleTargets();
  const rulesQuery = useRules(targetFilter || undefined);

  if (targetsQuery.isPending || rulesQuery.isPending || targetsQuery.error || rulesQuery.error) {
    return (
      <PageTemplate title="Rules">
        <Card raised>
          <EmptyState>
            {targetsQuery.error || rulesQuery.error
              ? `Could not load rules: ${(targetsQuery.error ?? rulesQuery.error)?.message}`
              : 'Loading rules…'}
          </EmptyState>
        </Card>
      </PageTemplate>
    );
  }

  const targets = targetsQuery.data;
  const rules = rulesQuery.data;

  return (
    <PageTemplate title="Rules" meta="Targets are the servers and applications rules evaluate against.">
      <section className="flex flex-col gap-4" aria-label="Targets">
        <SectionHeader title="Targets" count={targets.length} description="Every server or application a rule can watch." onBand />
        <Card className="overflow-hidden">
          <RuleTargetsTable targets={targets} />
        </Card>
      </section>

      <section className="flex flex-col gap-4" aria-label="Rules">
        <SectionHeader
          title="Rules"
          count={rules.length}
          description="Thresholds evaluated on each poll."
          actions={
            <Combobox
              options={[{ value: ALL_TARGETS, label: 'All targets' }, ...targets.map((t) => ({ value: t.id, label: t.name }))]}
              value={targetFilter}
              onChange={setTargetFilter}
              className="min-w-[220px]"
            />
          }
        />
        <Card className="overflow-hidden">
          <RulesTable rules={rules} targets={targets} />
        </Card>
      </section>
    </PageTemplate>
  );
}
